

(function () {
  'use strict';

  
  if (window.__veeryWishlistReady) return;
  window.__veeryWishlistReady = true;

  
  
  
  var STORAGE_KEY = 'veery_wishlist';
  var memoryStore = null; 

  
  function storageAvailable() {
    try {
      var k = '__veery_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }
  var useLocalStorage = storageAvailable();

  
  function readStore() {
    if (!useLocalStorage) {
      return memoryStore ? memoryStore.slice() : [];
    }
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Object.prototype.toString.call(parsed) === '[object Array]' ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  
  function writeStore(arr) {
    if (!useLocalStorage) {
      memoryStore = arr.slice();
      return;
    }
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
    } catch (e) {
      
      memoryStore = arr.slice();
    }
  }

  
  
  
  var handles = readStore();          
  var subscribers = [];               
  var productCache = {};              

  
  function emitChange() {
    var snapshot = handles.slice();
    for (var i = 0; i < subscribers.length; i++) {
      try { subscribers[i](snapshot); } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('veery:wishlist:change', {
        detail: { handles: snapshot, count: snapshot.length }
      }));
    } catch (e) {
      
      var ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('veery:wishlist:change', true, false, {
        handles: snapshot, count: snapshot.length
      });
      document.dispatchEvent(ev);
    }
  }

  
  function indexOf(handle) {
    for (var i = 0; i < handles.length; i++) {
      if (handles[i] === handle) return i;
    }
    return -1;
  }

  
  
  
  var API = {
    getAll: function () {
      return handles.slice();
    },

    has: function (handle) {
      return indexOf(handle) !== -1;
    },

    count: function () {
      return handles.length;
    },

    add: function (handle) {
      if (!handle || this.has(handle)) return;
      handles.push(handle);
      writeStore(handles);
      emitChange();
    },

    
    insertAt: function (handle, index) {
      if (!handle || this.has(handle)) return;
      var i = typeof index === 'number' && index >= 0 && index <= handles.length ? index : handles.length;
      handles.splice(i, 0, handle);
      writeStore(handles);
      emitChange();
    },

    remove: function (handle) {
      var i = indexOf(handle);
      if (i === -1) return;
      handles.splice(i, 1);
      writeStore(handles);
      emitChange();
    },

    
    toggle: function (handle) {
      if (!handle) return false;
      if (this.has(handle)) {
        this.remove(handle);
        return false;
      }
      this.add(handle);
      return true;
    },

    clear: function () {
      handles = [];
      writeStore(handles);
      emitChange();
    },

    
    subscribe: function (fn) {
      if (typeof fn !== 'function') return function () {};
      subscribers.push(fn);
      return function () {
        for (var i = 0; i < subscribers.length; i++) {
          if (subscribers[i] === fn) { subscribers.splice(i, 1); break; }
        }
      };
    },

    

    
    escapeHtml: function (str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    
    formatMoney: function (cents) {
      try {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents);
        }
      } catch (e) {}
      
      try {
        var m = String(window.veeryMoneyMuestra || '').match(/^(\D*?)1(\D?)234(\D)56(\D*)$/);
        if (m) {
          var n = Math.round(Number(cents)) || 0;
          var entero = String(Math.floor(Math.abs(n) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
          var dec = String(Math.abs(n) % 100).padStart(2, '0');
          return (n < 0 ? '-' : '') + m[1] + entero + m[3] + dec + m[4];
        }
      } catch (e) {}
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      });
    },

    
    fetchProduct: function (handle) {
      if (productCache[handle]) {
        return Promise.resolve(productCache[handle]);
      }
      var raizIdioma = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(raizIdioma + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('not found');
          return res.json();
        })
        .then(function (data) {
          productCache[handle] = data;
          return data;
        });
    }
  };

  window.VeeryWishlist = API;

  
  
  
  
  
  
  
  
  
  function labelFor(btn, saved) {
    if (saved) {
      return btn.getAttribute('data-label-remove') || 'Remove from wishlist';
    }
    return btn.getAttribute('data-label-add') || 'Add to wishlist';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-veery-wishlist]') : null;
    if (!btn) return;

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();

    var nowSaved = API.toggle(handle);

    
    btn.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
    btn.setAttribute('aria-label', labelFor(btn, nowSaved));
    btn.classList.remove('is-animating');
    
    void btn.offsetWidth;
    btn.classList.add('is-animating');
  });

  
  
  
  
  function syncHearts() {
    var hearts = document.querySelectorAll('[data-veery-wishlist]');
    for (var i = 0; i < hearts.length; i++) {
      var h = hearts[i].getAttribute('data-product-handle');
      var saved = h ? API.has(h) : false;
      hearts[i].setAttribute('aria-pressed', saved ? 'true' : 'false');
      hearts[i].setAttribute('aria-label', labelFor(hearts[i], saved));
    }
  }

  
  function syncBadges() {
    var n = API.count();
    var badges = document.querySelectorAll('[data-veery-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = n;
      if (n > 0) {
        badges[i].removeAttribute('data-empty');
      } else {
        badges[i].setAttribute('data-empty', 'true');
      }
    }
  }

  
  var handleWishlistChange = function () {
    syncHearts();
    syncBadges();
  };
  document.addEventListener('veery:wishlist:change', handleWishlistChange);

  
  var handleStorageChange = function (e) {
    if (e.key !== STORAGE_KEY) return;
    handles = readStore();
    emitChange();
  };
  if (useLocalStorage) {
    window.addEventListener('storage', handleStorageChange);
  }

  
  function bootstrap() {
    syncHearts();
    syncBadges();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  
  document.addEventListener('shopify:section:load', bootstrap);

  
  var badgesVigilados = typeof WeakSet === 'function' ? new WeakSet() : null;
  function restaurarSiPisado() {
    var n = API.count();
    if (n === 0) return;
    var badges = document.querySelectorAll('[data-veery-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      if (badges[i].hasAttribute('data-empty') || badges[i].textContent !== String(n)) {
        syncBadges();
        return;
      }
    }
  }
  function vigilarBadges() {
    if (!('MutationObserver' in window)) return;
    var badges = document.querySelectorAll('[data-veery-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      if (badgesVigilados && badgesVigilados.has(b)) continue;
      new MutationObserver(restaurarSiPisado).observe(b, {
        attributes: true, attributeFilter: ['data-empty'],
        childList: true, characterData: true, subtree: true
      });
      if (badgesVigilados) badgesVigilados.add(b);
    }
  }
  vigilarBadges();
  document.addEventListener('cart:update', function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        vigilarBadges();
        restaurarSiPisado();
      });
    });
  });
})();